module.exports = __webpack_public_path__ + "static/media/CodeIcon.73c777d2.svg";